import React, { useState } from "react";
import { Box, Tabs, Tab, Grid } from "@mui/material";
import EventIcon from "@mui/icons-material/Event"; // example icon
import MetricCard from "../admin-widgets/MetricsCard";

// Explicitly type allowed packages
type PackageType = "X" | "Pro" | "Luxe";

const BookingStatsWidget: React.FC = () => {
  const [selectedPackage, setSelectedPackage] = useState<PackageType>("X");

  // Example booking data (you can fetch from API)
  const bookingCounts: Record<PackageType, number> = {
    X: 124,
    Pro: 87,
    Luxe: 56,
  };

  const handleChange = (event: React.SyntheticEvent, newValue: PackageType) => {
    setSelectedPackage(newValue);
  };

  // Pick color per package for styling
  const packageColors: Record<PackageType, string> = {
    X: "#1976d2",
    Pro: "#9c27b0",
    Luxe: "#ff9800",
  };

  return (
    <Box>
      {/* Filter Tabs */}
      <Tabs
        value={selectedPackage}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="package filter"
      >
        <Tab label="Muzukuru X" value="X" />
        <Tab label="Muzukuru Pro" value="Pro" />
        <Tab label="Muzukuru Luxe" value="Luxe" />
      </Tabs>

      {/* Metric Card */}
      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <MetricCard
            title={`Bookings - Muzukuru ${selectedPackage}`}
            value={bookingCounts[selectedPackage]}
            icon={EventIcon}
            color={packageColors[selectedPackage]}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BookingStatsWidget;
